import { createContext } from 'react';

const AppContext = createContext({
  isFluid: false,
  isRTL: false,
  isDark: false,
  showBurgerMenu: false,
  currency: '$',
  isNavbarVerticalCollapsed: false,
  isTopNav: false,
  user: null
});

export const NotificationContext = createContext({ notifications: [], setNotifications: () => { } });
export const SocketContext = createContext({ echo: null });
export const CurrencyContext = createContext({
  currency: {
    name: '',
    iso: ''
  },
  setCurrency: () => { },
  loading: false,
  setLoading: () => { },
  baseCurrency: { iso: 'USD', symbol: '$', name: 'Dolar' },
  setBaseCurrency: () => { }
});

export const EmailContext = createContext({ emails: [] });
export const ProductContext = createContext({ products: [] });
export const FeedContext = createContext({ feeds: [] });
export const AuthWizardContext = createContext({ user: {} });
export const ChatContext = createContext();
export default AppContext;
